import Highcharts from 'highcharts';
import { parseISO } from 'date-fns';

import LanguageProvider from '@/providers/languageProvider';

class ChartUtils {
    static getExportingOptions(): Highcharts.ExportingOptions {
        return {
            enabled: true,
            buttons: {
                contextButton: {
                    menuItems: ['downloadJPEG', 'downloadPNG', 'downloadCSV', 'downloadXLS', 'viewFullscreen']
                }
            },
        };
    }

    static getLanguageOptions(): Highcharts.LangOptions {
        return {
            contextButtonTitle: LanguageProvider.getTranslation("pages.realestateutilization.charts.general.contextbuttontitle"),
            downloadJPEG: LanguageProvider.getTranslation("pages.realestateutilization.charts.general.downloadjpg"),
            downloadCSV: LanguageProvider.getTranslation("pages.realestateutilization.charts.general.downloadcsv"),
            downloadPNG: LanguageProvider.getTranslation("pages.realestateutilization.charts.general.downloadpng"),
            downloadXLS: LanguageProvider.getTranslation("pages.realestateutilization.charts.general.downloadxls"),
            exitFullscreen: LanguageProvider.getTranslation("pages.realestateutilization.charts.general.exitfullscreen"),
            viewFullscreen: LanguageProvider.getTranslation("pages.realestateutilization.charts.general.viewfullscreen"),
        }
    }

    static getTitle(title: string, className: string = "chart-title"): Highcharts.TitleOptions {

        const titleOptions: Highcharts.TitleOptions = {
            text: `<span class="${className}">${title}</span>`,
            useHTML: true,
            align: 'center',
            x: 50,
        };

        return titleOptions;
    }

    static convertDates(obj: any): any {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                if (typeof value === 'string' && !isNaN(Date.parse(value))) {
                    obj[key] = parseISO(value);
                }
            }
        }
        return obj;
    }

    static getMonthnames(): string[] {
        const monthNames = [
            LanguageProvider.getTranslation("dates.january"),
            LanguageProvider.getTranslation("dates.february"),
            LanguageProvider.getTranslation("dates.march"),
            LanguageProvider.getTranslation("dates.april"),
            LanguageProvider.getTranslation("dates.may"),
            LanguageProvider.getTranslation("dates.june"),
            LanguageProvider.getTranslation("dates.july"),
            LanguageProvider.getTranslation("dates.august"),
            LanguageProvider.getTranslation("dates.september"),
            LanguageProvider.getTranslation("dates.october"),
            LanguageProvider.getTranslation("dates.november"),
            LanguageProvider.getTranslation("dates.december")
        ];
        return monthNames;
    }

    static getShortHandMonthnames(): string[] {
        const monthNames = [
            LanguageProvider.getTranslation("dates.shorthand.january"),
            LanguageProvider.getTranslation("dates.shorthand.february"),
            LanguageProvider.getTranslation("dates.shorthand.march"),
            LanguageProvider.getTranslation("dates.shorthand.april"),
            LanguageProvider.getTranslation("dates.shorthand.may"),
            LanguageProvider.getTranslation("dates.shorthand.june"),
            LanguageProvider.getTranslation("dates.shorthand.july"),
            LanguageProvider.getTranslation("dates.shorthand.august"),
            LanguageProvider.getTranslation("dates.shorthand.september"),
            LanguageProvider.getTranslation("dates.shorthand.october"),
            LanguageProvider.getTranslation("dates.shorthand.november"),
            LanguageProvider.getTranslation("dates.shorthand.december")
        ];
        return monthNames;
    }

    static formatTime(decimalTime: number): string {
        const hours = Math.floor(decimalTime);
        const minutes = Math.round((decimalTime - hours) * 60);
        return `${hours}h ${minutes}m`;
    }

    static formatString(template: string, ...args: any[]): string {
        if (!template) { return ""; }

        return template.replace(/{(\d+)}/g, (match, index) => {
            return typeof args[index] !== 'undefined' ? args[index] : match;
        });
    }

    static padLeft(value: number | string | undefined, length: number, char: string = '0'): string {
        if (value === undefined) { return ""; }
        return value.toString().padStart(length, char);
    }
}

export default ChartUtils;
